import React from "react";
import { ACTIONS } from "../state/contexts/quizState";
import { useQuiz } from "../services/hooks/useQuiz";

export default React.memo(function QuizQ3({ isActive }) {
  const { setAnswer, quizResponses } = useQuiz();

  const { hairColor } = quizResponses;

  const setHairColor = (answer) => {
    setAnswer(ACTIONS.SET_HAIR_COLOR, {
      hairColor: answer,
    });
  };

  const options = [
    {
      title: "Black",
      swatchClass: "hair-1",
    },
    {
      title: "Dark Brown",
      swatchClass: "hair-2",
    },
    {
      title: "Light Brown",
      swatchClass: "hair-3",
    },
    {
      title: "Blonde",
      swatchClass: "hair-4",
    },
    {
      title: "Red",
      swatchClass: "hair-5",
    },
    {
      title: "Gray",
      swatchClass: "hair-6",
    },
    {
      title: "White",
      swatchClass: "hair-7",
    },
    {
      title: "Other",
      swatchClass: "hair-8",
    },
  ];

  const listItems = options.map(({ title, swatchClass }) => (
    <div
      key={title}
      className="choice"
      role="button"
      tabIndex="0"
      aria-pressed={hairColor === title}
      onClick={() => {
        setHairColor(title);
      }}
    >
      <div className="answer-container">
        <div
          className={`cbb-check icon-cbb-check-large fa fa-check ${
            hairColor === title ? "checked" : ""
          }`}
        ></div>
        <div className={`swatch ${swatchClass}`}></div>
        <div className="label">{title}</div>
      </div>
    </div>
  ));

  if (!isActive) {
    return null;
  }

  return (
    <React.Fragment>
      <h4 className="mb-8">What color is your hair?</h4>

      <div className="answer-swatch single" id="quiz-answer-grid">
        {listItems}
      </div>
    </React.Fragment>
  );
});
